import { recordFromSnapshot } from 'utils/firebaseUtils'
import { createTransactionForBar } from 'redux/modules/transaction'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_BAR_ERROR = 'CREATE_BAR_ERROR'
export const CREATE_BAR_SUCCESS = 'CREATE_BAR_SUCCESS'
export const DELETE_BAR_ERROR = 'DELETE_BAR_ERROR'
export const DELETE_BAR_SUCCESS = 'DELETE_BAR_SUCCESS'
export const UPDATE_BAR_ERROR = 'UPDATE_BAR_ERROR'
export const UPDATE_BAR_SUCCESS = 'UPDATE_BAR_SUCCESS'
export const ADD_SIDE_BAR = 'ADD_SIDE_BAR'
export const REMOVE_SIDE_BAR = 'REMOVE_SIDE_BAR'
export const SELECT_CURRENT_BAR = 'SELECT_CURRENT_BAR'
// ------------------------------------
// Actions
// ------------------------------------

export function addTransactionToBar(bar, transaction) {
  return (dispatch, getState) => {
    dispatch(updateBar(bar, { currentTransaction: transaction }))
  }
}

export function removeTransactionFromBar(bar) {
  return (dispatch, getState) => {
    dispatch(updateBar(bar, { currentTransaction: null }))
  }
}

export function selectCurrentBar(barKey) {
  return (dispatch, getState) => {
    const { bars } = getState()
    const bar = bars.list.filter(t => {
      return t.key === barKey
    })[0]
    if (bar) {
      dispatch({
        type: SELECT_CURRENT_BAR,
        payload: bar
      })
    }
  }
}
export function createBar(name) {
  return (dispatch, getState) => {
    const { firebase, bars } = getState()
    const barKey = firebase.child('bars').push().key
    const bar = {
      name: !name ? 'Bar ' + bars.nextNum : name,
      num: bars.nextNum
    }
    firebase.child(`bars/${barKey}`).set(bar, error => {
      if (error) {
        console.error('ERROR @ createBAR :', error)
        dispatch({
          type: CREATE_BAR_ERROR,
          payload: error
        })
      }
      dispatch(createTransactionForBar({ ...bar, key: barKey }))
    })
  }
}

export function deleteBar(bar) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('bars/' + bar.key).remove(error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: DELETE_BAR_ERROR,
          payload: error
        })
      }
    })
  }
}
export function updateBarInfo(transaction, bar) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    let fanout = {}
    fanout[`bars/${transaction.bar.key}/name`] = bar.name
    fanout[`bars/${transaction.bar.key}/color`] = bar.color || null
    fanout[`transactions/${transaction.key}/bar/name`] = bar.name
    fanout[`transactions/${transaction.key}/bar/color`] = bar.color || null
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ updateBar :', error)
        dispatch({
          type: UPDATE_BAR_ERROR,
          payload: error
        })
      }
    })
  }
}
export function updateBar(bar, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()

    firebase.child('bars/' + bar.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateBar :', error)
        dispatch({
          type: UPDATE_BAR_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerBarsListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('bars').orderByChild('index')
    ref.on('child_added', snapshot =>
      dispatch({
        type: CREATE_BAR_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_changed', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      if (payload.currentTransaction && payload.currentTransaction.canceled) {
        dispatch({
          type: DELETE_BAR_SUCCESS,
          payload: payload
        })
        return
      }
      dispatch({
        type: UPDATE_BAR_SUCCESS,
        payload: payload
      })
      if (payload.key === getState().bars.currentBar.key) {
        dispatch({
          type: SELECT_CURRENT_BAR,
          payload: payload
        })
      }
    })

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_BAR_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createBar,
  updateBar,
  selectCurrentBar,
  registerBarsListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_BAR_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(bar => bar.key === action.payload.key)
    let index = 1
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    list = list.sort((a, b) => a.key - b.key)
    for (let i = 0; i < list.length; i++) {
      if (Number(list[i].num) <= index) {
        index = Number(list[i].num)
        index++
      }
    }
    return Object.assign({}, state, { list: list, nextNum: index })
  },
  [CREATE_BAR_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_BAR_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(bar => {
        return bar.key === action.payload.key ? action.payload : bar
      })
    }),
  [UPDATE_BAR_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_BAR_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(bar => {
        return bar.key !== action.payload.key
      }),
      nextNum:
        action.payload.num < state.nextNum
          ? Number(action.payload.num)
          : state.nextNum
    }),
  [DELETE_BAR_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CURRENT_BAR]: (state, action) =>
    Object.assign({}, state, { currentBar: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], currentBar: {}, nextNum: 1 }
export default function barReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/bar.js